// src/api/adminService.js
import axiosInstance from './axiosInstance';

// Obtener todas las ventanas
export const fetchWindows = async () => {
  const response = await axiosInstance.get('/windows');
  return response.data;
};

// Crear una nueva ventana
export const createWindow = async (data) => {
  const response = await axiosInstance.post('/windows', data);
  return response.data;
};

// Actualizar una ventana
export const updateWindow = async (id, data) => {
  const response = await axiosInstance.put(`/windows/${id}`, data);
  return response.data;
};

// Eliminar una ventana
export const deleteWindow = async (id) => {
  const response = await axiosInstance.delete(`/windows/${id}`);
  return response.data;
};

/*==========FUNCIONES==============*/

// Obtener todas las funciones
export const fetchFunctions = async () => {
  const response = await axiosInstance.get('/functions');
  return response.data;
};

// Crear una nueva funcion
export const createFunction = async (data) => {
  const response = await axiosInstance.post('/functions', data);
  return response.data;
};

// Actualizar una funcion
export const updateFunction = async (id, data) => {
  const response = await axiosInstance.put(`/functions/${id}`, data);
  return response.data;
};

// Eliminar una funcion
export const deleteFunction = async (id) => {
  const response = await axiosInstance.delete(`/functions/${id}`);
  return response.data;
};

/*==========ROLES==============*/

// Obtener todas las funciones
export const fetchRoles = async () => {
  const response = await axiosInstance.get('/roles');
  return response.data;
};

// Crear una nueva funcion
export const createRol = async (data) => {
  const response = await axiosInstance.post('/roles', data);
  return response.data;
};

// Actualizar una funcion
export const updateRol = async (id, data) => {
  const response = await axiosInstance.put(`/roles/${id}`, data);
  return response.data;
};

// Eliminar una funcion
export const deleteRol = async (id) => {
  const response = await axiosInstance.delete(`/roles/${id}`);
  return response.data;
};

/*=======EMPLEADOS=========*/
export const fetchEmployees = async () => {
  const response = await axiosInstance.get('/employees');
  return response.data;
};

export const createEmployee = async (data) => {
  const response = await axiosInstance.post('/employees', data);
  return response.data;
};

export const updateEmployee = async (id, data) => {
  const response = await axiosInstance.put(`/employees/${id}`, data);
  return response.data;
};

export const deleteEmployee = async (id) => {
  const response = await axiosInstance.delete(`/employees/${id}`);
  return response.data;
};

export const getEmpleadoById = async (id) => {
  const response = await axiosInstance.get(`/employees/${id}`);
  return response.data;
};